module.exports = __webpack_public_path__ + "static/media/i.dfe4a60e.png";